import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DataService } from './shared/data.service';
import { SecurityService } from './security/security.service';
import { CustomerProfile } from './security/models/customer-profile.model';
import { Addr } from './shared/model/addr.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'KSolve';
  buttonSelected: string = "Home";
  custProfile = new CustomerProfile();


  constructor(public dataSvc: DataService, private authSvc: SecurityService, private router: Router) {
  }

  ngOnInit() {


    //If the application is restarting, clear previous login related entries from local storage and share data service. User will need to log in again.
    if (environment.production) {
      localStorage.removeItem('AuthToken');
      localStorage.removeItem('User');
      this.dataSvc.clearData();
    } else {
      //In dev environment do following so that you don't have to login each time
      if (!!localStorage.getItem('AuthToken')) {
        this.authSvc.getCustomerProfileByLoginId(localStorage.getItem('User')).subscribe(
          res => {
            this.custProfile = res;
            if (this.custProfile.homeOrOfficeAddress == null) {
              this.custProfile.homeOrOfficeAddress = new Addr();
            }
            if (this.custProfile.mailingOrShippingAddress == null) {
              this.custProfile.mailingOrShippingAddress = new Addr();
            }

            this.dataSvc.setCustomerProfile(this.custProfile);
          },
          err => console.log("Login error: " + err)
        );

      }
    }
  }



  ngOnDestroy() {

  }



}
